export default __webpack_public_path__ + "static/media/text.c94ecd76.png";